class StickySiteHeader extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    document.addEventListener("load", (event) => {
      this.onWindowLoadPosition(event)
    });

    document.addEventListener("scroll", (event) => {
      this.onWindowScroll(event)
    });

    const toggleMobileMenu = (e) => {
      this.onMobileMenuToggle()
    }

    const mobileMenuButton = document.querySelector('[data-drawers-trigger="menu"]')
    mobileMenuButton.addEventListener('click', toggleMobileMenu)

    const mobileMenuBackground = document.querySelector('[data-site-drawers-el="backdrop"]')
    mobileMenuBackground.addEventListener('click', toggleMobileMenu)
  }

  onWindowLoadPosition(event) {
    const siteBody = document.querySelector('body');
    const announcementBar = document.querySelector('.hd-Announcement');
    const announcementBarHeight = announcementBar.offsetHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if(announcementBar) {
      if (scrollTop > announcementBarHeight) {
        siteBody.classList.add('util-HeaderScroll');
      } else {
        siteBody.classList.remove('util-HeaderScroll');
      }
    } else {
      if (scrollTop > 0 ) {
        siteBody.classList.add('util-HeaderScroll');
      } else {
        siteBody.classList.remove('util-HeaderScroll');
      }
    }
  }

  onWindowScroll(event) {
    const siteBody = document.querySelector('body');
    const announcementBar = document.querySelector('.hd-Announcement');
    const announcementBarHeight = announcementBar.offsetHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if(announcementBar) {
      if (scrollTop > announcementBarHeight) {
        siteBody.classList.add('util-HeaderScroll');
      } else {
        siteBody.classList.remove('util-HeaderScroll');
      }
    } else {
      if (scrollTop > 0 ) {
        siteBody.classList.add('util-HeaderScroll');
      } else {
        siteBody.classList.remove('util-HeaderScroll');
      }
    }
  }

  onMobileMenuToggle () {
    const siteBody = document.querySelector('body')
    siteBody.classList.toggle('util-MobileMenuOpen')
  }
}


customElements.define('sticky-site-header', StickySiteHeader)